import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Thermometer, Settings, Gauge } from "lucide-react";
import { useNavigate } from "react-router-dom";

export function ClimatePreviewSection() {
  const navigate = useNavigate();

  const handleNavigateToSmartHome = () => {
    navigate("/smarthome#climate");
  };

  const handleNavigateToWarmtepomp = () => {
    navigate("/warmtepompen");
  };

  return (
    <section className="py-16 bg-gradient-to-b from-background to-muted/20">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-2 mb-4">
            <Thermometer className="h-8 w-8 text-primary" />
            <h2 className="text-3xl font-bold">Slimme Klimaatregeling</h2>
          </div>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Perfecte temperatuurcontrole met intelligente stelventiel actuatoren en klimaatbesturing
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-8">
          <Card className="group hover:shadow-lg transition-all duration-300 overflow-hidden">
            <div className="aspect-video bg-muted">
              <video 
                className="w-full h-full object-cover"
                autoPlay 
                loop 
                muted 
                playsInline
              >
                <source src="https://pim.loxone.com//01%20Product%20Data/01%20Products/Climate/100602%20-%20Stellantrieb%20Tree/Images/vi-overview-100602-valve-actuator.webm" type="video/webm" />
                Video niet ondersteund
              </video>
            </div>
            <CardContent className="p-6 text-center">
              <h3 className="text-xl font-semibold mb-2">Valve Actuator Tree</h3>
              <p className="text-muted-foreground text-sm">
                Precisie stelventiel actuatoren voor optimale temperatuurregeling per ruimte
              </p>
            </CardContent>
          </Card>

          <Card className="group hover:shadow-lg transition-all duration-300 overflow-hidden">
            <div className="aspect-video bg-muted">
              <video 
                className="w-full h-full object-cover"
                autoPlay 
                loop 
                muted 
                playsInline
              >
                <source src="https://pim.loxone.com//01%20Product%20Data/01%20Products/Basics%20%26%20Accessories/100116%20-%20Multi%20Extension%20Air/Images/vi-overview-100116-multi-extension.webm" type="video/webm" />
                Video niet ondersteund
              </video>
            </div>
            <CardContent className="p-6 text-center">
              <h3 className="text-xl font-semibold mb-2">Automatische Regeling</h3>
              <p className="text-muted-foreground text-sm">
                Intelligente klimaatcontrole die zich aanpast aan uw dagritme en aanwezigheid
              </p>
            </CardContent>
          </Card>

          <Card className="group hover:shadow-lg transition-all duration-300">
            <CardContent className="p-6 text-center">
              <Thermometer className="h-12 w-12 text-primary mx-auto mb-4" />
              <h3 className="text-xl font-semibold mb-2">Energiebesparing</h3>
              <p className="text-muted-foreground text-sm">
                Tot 30% besparing op verwarmingskosten door zone-gebaseerde temperatuurcontrole
              </p>
            </CardContent>
          </Card>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button onClick={handleNavigateToWarmtepomp} size="lg" className="px-8">
            Warmtepomp Diensten
          </Button>
          <Button onClick={handleNavigateToSmartHome} variant="outline" size="lg" className="px-8">
            Klimaat in Smart Home
          </Button>
        </div>
      </div>
    </section>
  );
}